export default __webpack_public_path__ + "static/media/tick.32c0d830.svg";